import React from 'react';
import { createPortal } from 'react-dom';
import './Loader.css';

interface LoaderProps {
  isLoading: boolean;
  message?: string;
}

const bars = [
  { animationDelay: "-1.2s", transform: "rotate(.0001deg) translate(146%)" },
  { animationDelay: "-1.1s", transform: "rotate(30deg) translate(146%)" },
  { animationDelay: "-1.0s", transform: "rotate(60deg) translate(146%)" },
  { animationDelay: "-0.9s", transform: "rotate(90deg) translate(146%)" },
  { animationDelay: "-0.8s", transform: "rotate(120deg) translate(146%)" },
  { animationDelay: "-0.7s", transform: "rotate(150deg) translate(146%)" },
  { animationDelay: "-0.6s", transform: "rotate(180deg) translate(146%)" },
  { animationDelay: "-0.5s", transform: "rotate(210deg) translate(146%)" },
  { animationDelay: "-0.4s", transform: "rotate(240deg) translate(146%)" },
  { animationDelay: "-0.3s", transform: "rotate(270deg) translate(146%)" },
  { animationDelay: "-0.2s", transform: "rotate(300deg) translate(146%)" },
  { animationDelay: "-0.1s", transform: "rotate(330deg) translate(146%)" },
];

const Loader: React.FC<LoaderProps> = ({ isLoading, message = "Processing..." }) => {
  if (!isLoading) return null;

  return createPortal(
    <div className="iqadmin-loader-overlay">
      <div className="iqadmin-loader-container">
        <div className="iqadmin-spinner" style={{ width: 48, height: 48 }}>
          {bars.map((item, i) => (
            <div
              key={i}
              className="iqadmin-spinner-bar"
              style={{ backgroundColor: '#059669', animation: "iqadminSpin 1.2s linear infinite", ...item }}
            />
          ))}
        </div>
        {message && <div className="iqadmin-loader-text">{message}</div>}
      </div>
    </div>,
    document.body
  );
};

export default Loader;
